import React from "react";
import { DashboardRoutes } from "./DashboardRoutes";

export const Dashboard = () => {
  return (
    <div>
      <DashboardRoutes></DashboardRoutes>
    </div>
  );
}